module.exports = __webpack_public_path__ + "img/zhaocha_des_2.7f9815cc.jpg";